import classNames from "classnames";
import { WhiteTick } from "components/icons/WhiteTick";
import { StepStatus } from "./types";

type StepRailProps = {
  number: number;
  status: StepStatus;
  isLast: boolean;
};

const StepIcon = ({
  number,
  status,
}: {
  number: number;
  status: StepStatus;
}) => {
  if (status === "done") {
    return (
      <div className="t-flex t-h-8 t-w-8 t-items-center t-justify-center t-rounded-full t-bg-dark_green">
        <WhiteTick />
      </div>
    );
  }

  if (status === "active") {
    return (
      <div className="t-flex t-h-8 t-w-8 t-items-center t-justify-center t-rounded-full t-bg-purple t-text-white t-text-button-sm t-ring-4 t-ring-purple-10">
        {number}
      </div>
    );
  }

  return (
    <div className="t-flex t-h-8 t-w-8 t-items-center t-justify-center t-rounded-full t-border t-border-solid t-border-neutral-20 t-bg-white t-text-button-sm t-text-neutral-30">
      {number}
    </div>
  );
};

export const StepRail = ({ number, status, isLast }: StepRailProps) => {
  return (
    <div className="t-flex t-w-8 t-shrink-0 t-flex-col t-items-center t-pt-5 sm:t-hidden">
      <StepIcon number={number} status={status} />
      {!isLast && (
        <div
          className={classNames("t-mt-2 t-w-px t-flex-1", {
            "t-bg-dark_green-20": status === "done",
            "t-bg-neutral-10": status !== "done",
          })}
        />
      )}
    </div>
  );
};
